<template>
  <b-card no-body>
    <b-card-header class="pb-50">
      <h5>
        Filtrer
      </h5>
    </b-card-header>
    <b-card-body>
      <b-row>
        <b-col
          cols="12"
          md="4"
          class="mb-md-0 mb-2"
        >
          <label>Nom</label>
          <b-form-input
            :value="nomFilter"
            class="w-100"
            @input="(val) => $emit('update:nomFilter', val)"
          />
        </b-col>
        <b-col
          cols="12"
          md="4"
          class="mb-md-0 mb-2"
        >
          <label>Type</label>
          <v-select
            :value="siteTypeFilter"
            :options="siteTypeOptions"
            class="w-100 select-cursor"
            @input="(val) => $emit('update:siteTypeFilter', val)"
          ><div slot="no-options">
            Aucune option
          </div></v-select>
        </b-col>
        <b-col
          cols="12"
          md="4"
          class="mb-md-0 mb-2"
        >
          <label>Code par défaut</label>
          <b-form-input
            :value="codeFilter"
            class="w-100"
            @input="(val) => $emit('update:codeFilter', val)"
          />
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BRow, BCol, BFormInput,
} from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BFormInput,
    vSelect,
  },
  props: {
    nomFilter: {
      type: [String, null],
      default: null,
    },
    siteTypeFilter: {
      type: [String, null],
      default: null,
    },
    codeFilter: {
      type: [String, null],
      default: null,
    },
    siteTypeOptions: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
